import { render } from "./historyPenilaian.vue?vue&type=template&id=58e51228"
import script from "./historyPenilaian.vue?vue&type=script&lang=js"
export * from "./historyPenilaian.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__